export default __webpack_public_path__ + "static/8_27-457975194bf9ac9ecd6ac7319f030001.png";